// extracted by mini-css-extract-plugin
module.exports = {"newVendor":"styles_newVendor__2L6p_","additionalMargin":"styles_additionalMargin__1PHkE","disabled":"styles_disabled__TWl4D"};